import { render, staticRenderFns } from "./CheckoutDisplayUserData.vue?vue&type=template&id=bba2ab9a&scoped=true&"
import script from "./CheckoutDisplayUserData.vue?vue&type=script&lang=ts&"
export * from "./CheckoutDisplayUserData.vue?vue&type=script&lang=ts&"
import style0 from "./CheckoutDisplayUserData.vue?vue&type=style&index=0&id=bba2ab9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba2ab9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bba2ab9a')) {
      api.createRecord('bba2ab9a', component.options)
    } else {
      api.reload('bba2ab9a', component.options)
    }
    module.hot.accept("./CheckoutDisplayUserData.vue?vue&type=template&id=bba2ab9a&scoped=true&", function () {
      api.rerender('bba2ab9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/checkout/CheckoutDisplayUserData.vue"
export default component.exports